import * as React from 'react'
function SvgOrg(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M24 28v8h-8v-8h8zm12 0v8h-8v-8h8zm-24 0v8H4v-8h8zm10-14v4h10c1.2 0 2 .8 2 2v6h-4v-4h-8v4h-4v-4h-8v4H6v-6c0-1.2.8-2 2-2h10v-4h4zm2-10v8h-8V4h8z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgOrg
